import { useNavigate } from "react-router-dom";
import type { LessonSummary } from "@/types/lesson";
import { ProgressBar } from "@/components/ProgressBar/ProgressBar";

export function LessonCard({ lesson }: { lesson: LessonSummary }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`/lessons/${lesson.lessonId}`)}
      className="flex flex-col overflow-hidden rounded-3xl bg-white text-left shadow-md transition active:scale-[0.98]"
    >
      <img src={lesson.thumbnail} alt="" className="h-32 w-full object-cover" />
      <div className="flex flex-col gap-2 p-4">
        <h3 className="text-lg font-extrabold text-slate-800">
          {lesson.title}
        </h3>
        <p className="text-sm text-slate-500">
          {lesson.duration} min · Grade {lesson.grade}
        </p>
        <ProgressBar value={lesson.progress} />
        {lesson.completed && (
          <span className="text-sm font-bold text-emerald-600">
            ✓ Completed
          </span>
        )}
      </div>
    </button>
  );
}
